import script from "./UserStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStrip.vue?vue&type=script&setup=true&lang=js"

import "./UserStrip.vue?vue&type=style&index=0&id=0764184d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0764184d"]])

export default __exports__